import {Hero7} from "../../components";
import React from "react";

export default function BlogBanner() {
    return (
        <>
            <Hero7 key="hero"
                   titre={"Blog Talents Handicap Formation :<br/>L’actualité des formations,<br/>de l’inclusion et du handicap en entreprise."}
                   description={"Interviews, événements, bonnes pratiques et initiatives pour agir concrètement"}
                   image="/images/background/banner-blog-formation.png"
                   nomImage="Bannière du blog"
                   optionalClass="blog-banner"
            />
        </>
    );
};